import { render, staticRenderFns } from "./UpdateQcTestRmOrderItemPopUp.vue?vue&type=template&id=3be55130&scoped=true&"
import script from "./UpdateQcTestRmOrderItemPopUp.vue?vue&type=script&lang=js&"
export * from "./UpdateQcTestRmOrderItemPopUp.vue?vue&type=script&lang=js&"
import style0 from "./UpdateQcTestRmOrderItemPopUp.vue?vue&type=style&index=0&id=3be55130&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3be55130",
  null
  
)

export default component.exports